<mat-toolbar mat-dialog-title color="accent" class="primary flex justify-between align-center">

  <p class="white">{{ test?.description || 'TÍTULO DO TESTE DE PREPARAÇÃO' }}</p>

  <div class="flex">

    <img class="logo-size" src="/assets/img/logos/logo-sap-interna.png">

    <mat-icon class="pointer white" (click)="dialogRef.close()">close</mat-icon>

  </div>

</mat-toolbar>

<div mat-dialog-content class="mg1 h100" id="scrollWindow">

  <form [formGroup]="testForm">

    <div class="flex wd100 justify-between mt1">

      @if (formState == 0) {
        <p></p>
      }
      @if (formState != 0 && test?.result) {
        <p>{{ test.result }}</p>
      }

      <p>{{ counter || 0 }} {{ counter == 1 ? 'minuto restante' : 'minutos restantes'}}</p>

    </div>

    @for (question of test?.questions; track question; let x = $index) {
      <div class="mt1 text">
        <div formArrayName="questions">
          <div [formGroupName]="x">
            <h1 class="bold">{{ x + 1 }} - QUESTÃO</h1>
            <br>
              <p>{{ question?.description }}</p>
              <br>
                <h1 class="bold">ALTERNATIVAS</h1>
                <mat-radio-group formControlName="selected" [disabled]="data.view || formState != 0" required>
                  @for (alt of question?.alternatives; track alt; let v = $index) {
                    <div class="flex align-center mt1"
                      [style.background-color]="formState == 0 ? '' : isCorrect(letters[v], x) && isSelected(letters[v], x, v) ? '#7dff7d' : isSelected(letters[v], x, v) ? '#ffa8a8' : ''">
                      @if (question?.alternative_type_id != 6) {
                        <p>{{ letters[v] + ')'}} &nbsp; </p>
                      }
                      <mat-radio-button [style.margin-left]="question?.alternative_type_id == 6 ? '24.89px': ''"
                        [value]="letters[v]">
                        {{ alt.description }}
                      </mat-radio-button>
                    </div>
                  }
                </mat-radio-group>
                <mat-divider class="mt1"></mat-divider>
              </div>
            </div>
          </div>
        }

      </form>

    </div>

    <div mat-dialog-actions class="ml1 margin-footer">

      @if (formState != 0) {
        <button mat-raised-button color="primary" class="primary-action-btn mr1" (click)="tryAgain()">Refazer
        teste</button>
      }

      @if (!data?.view && formState == 0) {
        <button id="modalApplyBtn" mat-raised-button color="primary" class="secondary mr1" (click)="completeTest()" [disabled]="testForm.invalid"
        >Finalizar</button>
      }

      <button mat-raised-button mat-dialog-close>Fechar</button>

    </div>
